import { emptyCoachState } from '@aj/coach';
import type { CoachState, CoachStore } from '@aj/coach';

import { readMeta, writeMeta } from './db.js';

/**
 * The coach's memory, in `meta` rather than the event log.
 *
 * See `MetaValues.coach` for why. In short: the journal is the student's
 * record of what they did, and a dismissed tip is not part of that.
 */
export const coachStore: CoachStore = {
  async read(): Promise<CoachState> {
    return (await readMeta('coach')) ?? emptyCoachState;
  },
  async write(state: CoachState): Promise<void> {
    await writeMeta('coach', state);
  },
};
